import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function QualityDistributionChart({ data, model }) {
  // Categorize evaluations into quality buckets
  const qualityDistribution = React.useMemo(() => {
    if (!data || !model) return [];

    const evaluations = data.stats.models[model]?.evaluations || [];

    // Define quality buckets (can adjust these thresholds)
    const excellent = evaluations.filter(e => {
      const avg = (e.structured_score + e.point_coverage_score + e.faithfulness_score) / 3;
      return avg >= 0.8 && avg <= 1;
    }).length;

    const good = evaluations.filter(e => {
      const avg = (e.structured_score + e.point_coverage_score + e.faithfulness_score) / 3;
      return avg >= 0.6 && avg < 0.8;
    }).length;

    const average = evaluations.filter(e => {
      const avg = (e.structured_score + e.point_coverage_score + e.faithfulness_score) / 3;
      return avg >= 0.4 && avg < 0.6;
    }).length;

    const poor = evaluations.filter(e => {
      const avg = (e.structured_score + e.point_coverage_score + e.faithfulness_score) / 3;
      return avg > 0 && avg < 0.4;
    }).length;

    const invalid = evaluations.filter(e => {
      return e.structured_score === 0 &&
        e.point_coverage_score === 0 &&
        e.note_length_score === 0 &&
        e.faithfulness_score === 0;
    }).length;

    return [
      { name: 'Excellent (0.8-1.0)', value: excellent },
      { name: 'Good (0.6-0.79)', value: good },
      { name: 'Average (0.4-0.59)', value: average },
      { name: 'Poor (<0.4)', value: poor },
      { name: 'Invalid/Missing', value: invalid }
    ].filter(bucket => bucket.value > 0);
  }, [data, model]);

  const COLORS = ['#4CAF50', '#8BC34A', '#FFC107', '#FF5722', '#9E9E9E'];

  if (!data || !model || qualityDistribution.length === 0) {
    return (
      <div className="bg-white p-6 rounded-lg shadow text-center">
        <p className="text-gray-500">No quality distribution data available for {model}</p>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4 text-ktx-navy">Quality Distribution: {model}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={qualityDistribution}
            cx="50%"
            cy="50%"
            labelLine={true}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
            label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
          >
            {qualityDistribution.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => [`${value} evaluations`, 'Count']} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}